import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum FeesFormErrorStatesEnum {
    AssignFeeFailed = ErrorStateScheduleEnum.FeesFormErrorStatesStartIndex,
    FeeIsAlreadyAssigned,
    UnassignFeeFailed,
    FeeUpdateFailed
}
